// src/views/empresasFalidas.js
import React from "react";
import TabelaPaginada from "../components/TabelaPaginada";
import { mensagemErro, mensagemSucesso } from "../components/toastr";
import Card from "../components/card";
import ClipLoader from "react-spinners/ClipLoader";
import EmpresasFalidasService from "../app/service/empresasFalidasService";
import CardGroup from "../components/card-group";
import FormGroup from "../components/form-group";
import DatePicker from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import moment from "moment";
import { BlinkBlur, Commet, ThreeDot } from "react-loading-indicators";

class EmpresasFalidas extends React.Component {
  state = {
    empresas: [],
    paginaAtual: 1,
    registrosPorPagina: 20,
    totalPaginas: 1,
    loading: false,
    loadingRelatorio: false,
    dataInicio: null,
    dataFim: null,
    disabled: false,
    mensagem: ''
  };

  constructor() {
    super();
    this.service = new EmpresasFalidasService();
  }

  componentDidMount() {
    // Definir datas padrão para carregar tabela
    const anoAtual = new Date().getFullYear();
    const dataInicioDefault = new Date(anoAtual, 0, 1); // 01/01/ANO_ATUAL
    const dataFimDefault = new Date(); // Hoje

    this.setState(
      {
        dataInicio: dataInicioDefault,
        dataFim: dataFimDefault,
      },
      () => this.buscarEmpresas() // Chama busca inicial com as datas padrão
    );
  }

  buscarEmpresas = () => {
    const { dataInicio, dataFim } = this.state;

    this.setState({ loading: true });

    const filtros = {
      dataInicio: moment(dataInicio).format("DD/MM/yyyy"),
      dataFim: moment(dataFim).format("DD/MM/yyyy"),
    };

    this.service
      .listarEmpresasFalidas(filtros)
      .then((response) => {
        const empresas = response.data || [];
        const totalPaginas = Math.ceil(
          empresas.length / this.state.registrosPorPagina
        );

        this.setState({
          empresas,
          totalPaginas,
          loading: false,
        });
      })
      .catch(() => {
        mensagemErro("Erro ao buscar empresas falidas");
        this.setState({ loading: false });
      });
  };

  gerarRelatorio = () => {
    const { dataInicio, dataFim } = this.state;

    if (!dataInicio || !dataFim) {
      mensagemErro("Informe as datas para gerar o relatório.");
      return;
    }

    this.setState({ loadingRelatorio: true, disabled: true });

    const filtros = {
      dataInicio: moment(dataInicio).format("DD/MM/yyyy"),
      dataFim: moment(dataFim).format("DD/MM/yyyy"),
    };

    this.service
      .gerarRelatorioEmpresasFalidas(filtros)
      .then(() => {
        mensagemSucesso("Relatório gerado com sucesso!");
      })
      .catch(() => {
        mensagemErro("Erro ao gerar relatório.");
      })
      .finally(() => {
        this.setState({ loadingRelatorio: false, disabled: false });
      });
  };

  mudarPagina = (pagina) => {
    if (pagina > 0 && pagina <= this.state.totalPaginas) {
      this.setState({ paginaAtual: pagina });
    }
  };

  limpar = ()=> {
        this.setState({
            mensagem:'',
            dataInicio: null,
            dataFim: null
        });
    }

  render() {
    const {
      empresas,
      paginaAtual,
      registrosPorPagina,
      totalPaginas,
      loading,
      loadingRelatorio,
      dataInicio,
      dataFim,
    } = this.state;

    // Paginação dos dados
    const indiceInicial = (paginaAtual - 1) * registrosPorPagina;
    const dadosPaginados = empresas.slice(
      indiceInicial,
      indiceInicial + registrosPorPagina
    );

    // Configuração das colunas da tabela
    const colunas = [
      { label: "NIRE", campo: "nrNire" },
      { label: "NOME DA EMPRESA", campo: "nomeEmpresa" },
      { label: "CNPJ", campo: "nrCgc" },
    ];

    return (
      <Card title="Empresas Falidas">
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            {/*<ClipLoader size={50} color={"#28a745"} loading={loading} />*/}
            <BlinkBlur loading={loading} color="#65AE67" size={120} text="Buscando empresas...." textColor="#212529" style={{ fontSize: "14px" }} /> 
          </div>
        ) : (
          <>
            {/* Container com altura fixa e scroll */}
            <div
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                marginTop: "20px",
              }}
            >
              <TabelaPaginada
                dados={dadosPaginados}
                colunas={colunas}
                paginaAtual={paginaAtual}
                totalPaginas={totalPaginas}
                empresas={empresas}
                onPageChange={this.mudarPagina}
              />
            </div>

            {/* Rodapé - Total Empresas Falidas */}
            <span
              className=""
              style={{
                padding: "5px",
                marginTop: "5px",
                display: "block",
                textAlign: "right",
              }}
            >
              🏦 Total de Empresas ........ : {empresas.length}
            </span>

            {/* Formulário de datas */}
            <div className="form-data-empresas-falidas">
              <FormGroup label="Período da consulta: *" htmlFor="inputNome">
                <div className="row col-md-12 p-3">
                  <div className="col-md-3">
                    <DatePicker
                      selected={dataInicio}
                      onChange={(date) => this.setState({ dataInicio: date })}
                      className="form-control"
                      id="iniDate"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Data Início"
                      locale={ptBR}
                    />
                  </div>

                  <div className="col-md-3">
                    <DatePicker
                      selected={dataFim}
                      onChange={(date) => this.setState({ dataFim: date })}
                      className="form-control"
                      id="fimDate"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Data Fim"
                      locale={ptBR}
                    />
                  </div>
                   
                  <div className="btn-exportar col-md-3">
                     {/* Botão Exportar */}
                     <button onClick={this.gerarRelatorio} className="btn btn-success falidas" disabled={loadingRelatorio}>
                    <i className="pi pi-undo"> </i> Exportar
                    </button>
                 </div>
                 <div className="col-md-3 md:ml-[-40px]">
                    {loadingRelatorio && ( <ThreeDot loading={loadingRelatorio} color="#65AE67" size="medium" text="Gerando relatório..." textColor="#212529" /> )}

                 </div>
                   
                </div>
              </FormGroup>
           </div>

          </>
        )}
      </Card>
    );
  }
}

export default EmpresasFalidas;

  {/*<ClipLoader loading={loadingRelatorio} color="#32cd32" size={40}/>*/}